var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComodities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 540,
    viewBox: "0 0 1440 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10831_124069",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -230,
    width: 1440,
    height: 1080
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -230,
    width: 1440,
    height: 1080,
    fill: "url(#paint0_radial_10831_124069)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10831_124069)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10831_124069)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1080,
    transform: "translate(0 -230)",
    fill: "#0E122F"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: -14,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 58,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.034 155.678C977.28 153.64 975.305 151.805 973.146 150.207C972.955 150.072 972.728 150 972.494 150C972.261 150 972.033 150.072 971.842 150.207C969.688 151.806 967.717 153.641 965.966 155.678C962.061 160.188 960 164.943 960 169.428C960 172.763 961.317 175.96 963.661 178.318C966.005 180.676 969.185 182 972.5 182C975.815 182 978.995 180.676 981.339 178.318C983.683 175.96 985 172.763 985 169.428C985 164.943 982.939 160.188 979.034 155.678ZM980.433 170.763C980.139 172.418 979.347 173.943 978.164 175.132C976.982 176.321 975.466 177.117 973.82 177.413C973.759 177.423 973.698 177.428 973.636 177.429C973.351 177.428 973.077 177.321 972.867 177.126C972.657 176.932 972.528 176.666 972.504 176.38C972.481 176.095 972.565 175.81 972.74 175.584C972.915 175.358 973.168 175.206 973.449 175.159C975.803 174.76 977.8 172.751 978.199 170.38C978.249 170.081 978.416 169.814 978.662 169.639C978.908 169.463 979.213 169.393 979.51 169.444C979.807 169.495 980.072 169.662 980.247 169.91C980.421 170.157 980.491 170.464 980.44 170.763H980.433Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224 130V129.625H1223.62V130H1224ZM1224 202H1223.62V202.375H1224V202ZM1224 130V130.375H1296V130V129.625H1224V130ZM1296 202V201.625H1224V202V202.375H1296V202ZM1224 202H1224.38V130H1224H1223.62V202H1224Z",
    fill: "#785E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.62 159.64L1245.92 159.38V158.14H1252.32V159.38L1250.56 159.64V171.6L1252.32 171.82V173H1245.92V171.8L1247.62 171.6V159.64ZM1255.24 163.78L1253.96 163.42V162.04L1257.28 161.62H1257.34L1257.84 162.02V162.8L1257.82 163.28C1258.29 162.84 1258.9 162.46 1259.64 162.14C1260.39 161.82 1261.14 161.66 1261.9 161.66C1262.72 161.66 1263.35 161.813 1263.8 162.12C1264.27 162.413 1264.6 162.88 1264.8 163.52C1265 164.16 1265.1 165.027 1265.1 166.12V171.64L1266.32 171.8V173H1261.16V171.8L1262.24 171.64V166.12C1262.24 165.427 1262.2 164.887 1262.1 164.5C1262.01 164.1 1261.84 163.813 1261.58 163.64C1261.34 163.453 1261 163.36 1260.54 163.36C1259.78 163.36 1258.97 163.687 1258.1 164.34V171.62L1259.3 171.8V173H1254.08V171.8L1255.24 171.62V163.78ZM1271.92 173.22C1271.09 173.22 1270.35 173.027 1269.7 172.64C1269.04 172.24 1268.52 171.627 1268.14 170.8C1267.75 169.973 1267.56 168.94 1267.56 167.7C1267.56 166.58 1267.78 165.56 1268.24 164.64C1268.7 163.707 1269.38 162.967 1270.28 162.42C1271.17 161.873 1272.24 161.6 1273.5 161.6C1274 161.6 1274.48 161.653 1274.94 161.76V158.38L1272.98 158.1V157L1277.1 156.6H1277.16L1277.72 157.02V171.78H1278.8V172.92C1277.84 173.12 1277.04 173.22 1276.42 173.22C1275.99 173.22 1275.68 173.147 1275.5 173C1275.32 172.867 1275.24 172.593 1275.24 172.18V171.62C1274.89 172.087 1274.42 172.473 1273.82 172.78C1273.22 173.073 1272.58 173.22 1271.92 173.22ZM1272.96 171.56C1273.4 171.56 1273.78 171.473 1274.12 171.3C1274.46 171.113 1274.74 170.893 1274.94 170.64V163.36C1274.84 163.227 1274.64 163.113 1274.34 163.02C1274.04 162.927 1273.72 162.88 1273.38 162.88C1272.52 162.88 1271.84 163.253 1271.32 164C1270.81 164.733 1270.56 165.913 1270.56 167.54C1270.56 168.9 1270.78 169.913 1271.22 170.58C1271.66 171.233 1272.24 171.56 1272.96 171.56ZM1289.28 173.2C1288.84 173.2 1288.52 173.107 1288.32 172.92C1288.12 172.733 1288.02 172.453 1288.02 172.08V171.54C1287.66 171.98 1287.15 172.373 1286.5 172.72C1285.84 173.053 1285.19 173.22 1284.54 173.22C1283.26 173.22 1282.34 172.893 1281.8 172.24C1281.25 171.573 1280.98 170.48 1280.98 168.96V163.32L1279.98 163.04V161.9L1283.38 161.64H1283.4L1283.8 161.92V168.96C1283.8 169.933 1283.92 170.613 1284.16 171C1284.4 171.387 1284.84 171.58 1285.5 171.58C1286.28 171.58 1287.02 171.273 1287.7 170.66V163.32L1286.36 163.02V161.9L1289.98 161.64H1290.02L1290.5 161.92V171.76H1291.62L1291.6 172.9C1291.54 172.913 1291.3 172.967 1290.86 173.06C1290.42 173.153 1289.89 173.2 1289.28 173.2ZM1295.25 171.36C1295.36 171.52 1295.6 171.673 1295.97 171.82C1296.36 171.953 1296.74 172.02 1297.13 172.02C1297.76 172.02 1298.22 171.893 1298.53 171.64C1298.85 171.373 1299.01 171.027 1299.01 170.6C1299.01 170.16 1298.82 169.807 1298.43 169.54C1298.04 169.26 1297.39 168.92 1296.47 168.52L1295.91 168.28C1294.99 167.893 1294.3 167.427 1293.85 166.88C1293.4 166.333 1293.17 165.627 1293.17 164.76C1293.17 164.16 1293.35 163.627 1293.71 163.16C1294.07 162.68 1294.58 162.307 1295.23 162.04C1295.88 161.773 1296.64 161.64 1297.49 161.64C1298.12 161.64 1298.65 161.68 1299.09 161.76C1299.54 161.84 1300.02 161.947 1300.51 162.08C1300.78 162.173 1300.98 162.227 1301.11 162.24V164.86H1299.53L1299.07 163.34C1298.99 163.207 1298.81 163.087 1298.53 162.98C1298.25 162.873 1297.93 162.82 1297.57 162.82C1297.02 162.82 1296.58 162.94 1296.25 163.18C1295.93 163.407 1295.77 163.727 1295.77 164.14C1295.77 164.513 1295.88 164.827 1296.11 165.08C1296.34 165.32 1296.58 165.507 1296.85 165.64C1297.12 165.773 1297.61 165.993 1298.33 166.3C1299.05 166.607 1299.64 166.9 1300.11 167.18C1300.59 167.46 1300.98 167.827 1301.29 168.28C1301.61 168.72 1301.77 169.26 1301.77 169.9C1301.77 170.887 1301.38 171.687 1300.61 172.3C1299.84 172.913 1298.72 173.22 1297.27 173.22C1296.59 173.22 1295.98 173.16 1295.43 173.04C1294.9 172.92 1294.28 172.76 1293.57 172.56L1293.13 172.42V169.78H1294.79L1295.25 171.36ZM1306.76 173.18C1305.92 173.18 1305.3 172.987 1304.9 172.6C1304.5 172.213 1304.3 171.6 1304.3 170.76V163.42H1303V162.38C1303.11 162.34 1303.3 162.273 1303.58 162.18C1303.86 162.073 1304.07 161.987 1304.22 161.92C1304.45 161.747 1304.64 161.447 1304.8 161.02C1304.92 160.74 1305.14 160.047 1305.46 158.94H1307.06L1307.14 161.88H1310.2V163.42H1307.16V169.04C1307.16 169.787 1307.18 170.313 1307.22 170.62C1307.26 170.927 1307.35 171.127 1307.48 171.22C1307.61 171.3 1307.85 171.34 1308.18 171.34C1308.51 171.34 1308.86 171.307 1309.22 171.24C1309.58 171.16 1309.88 171.067 1310.12 170.96L1310.5 172.08C1310.13 172.36 1309.58 172.613 1308.86 172.84C1308.14 173.067 1307.44 173.18 1306.76 173.18ZM1311.56 171.82L1312.88 171.66V163.78L1311.6 163.42V162.04L1314.7 161.62H1314.76L1315.26 162.02V162.46L1315.2 164.08H1315.26C1315.36 163.813 1315.58 163.487 1315.92 163.1C1316.27 162.7 1316.7 162.353 1317.22 162.06C1317.76 161.753 1318.33 161.6 1318.94 161.6C1319.24 161.6 1319.49 161.64 1319.7 161.72V164.72C1319.3 164.44 1318.82 164.3 1318.24 164.3C1317.27 164.3 1316.42 164.56 1315.7 165.08V171.64L1318.02 171.82V173H1311.56V171.82ZM1323.36 160.06C1322.88 160.06 1322.5 159.92 1322.22 159.64C1321.94 159.36 1321.8 159 1321.8 158.56C1321.8 158.053 1321.96 157.633 1322.28 157.3C1322.6 156.967 1323.02 156.8 1323.56 156.8C1324.09 156.8 1324.5 156.947 1324.78 157.24C1325.06 157.52 1325.2 157.873 1325.2 158.3C1325.2 158.833 1325.04 159.26 1324.72 159.58C1324.4 159.9 1323.95 160.06 1323.38 160.06H1323.36ZM1322.3 163.78L1320.88 163.4V162.06L1324.54 161.62H1324.58L1325.14 162.02V171.64L1326.48 171.8V173H1320.9V171.8L1322.3 171.62V163.78ZM1327.69 169.88C1327.69 168.667 1328.3 167.753 1329.51 167.14C1330.74 166.527 1332.32 166.213 1334.25 166.2V165.74C1334.25 165.193 1334.19 164.767 1334.07 164.46C1333.97 164.153 1333.76 163.927 1333.45 163.78C1333.16 163.62 1332.73 163.54 1332.15 163.54C1331.5 163.54 1330.91 163.627 1330.39 163.8C1329.87 163.96 1329.33 164.173 1328.77 164.44L1328.15 163.16C1328.35 162.987 1328.69 162.78 1329.15 162.54C1329.63 162.3 1330.2 162.093 1330.85 161.92C1331.51 161.733 1332.18 161.64 1332.87 161.64C1333.9 161.64 1334.7 161.773 1335.27 162.04C1335.86 162.307 1336.28 162.733 1336.53 163.32C1336.79 163.907 1336.91 164.693 1336.91 165.68V171.8H1337.99V172.92C1337.73 172.987 1337.35 173.053 1336.85 173.12C1336.36 173.187 1335.93 173.22 1335.55 173.22C1335.1 173.22 1334.79 173.153 1334.63 173.02C1334.49 172.887 1334.41 172.613 1334.41 172.2V171.66C1334.05 172.06 1333.59 172.42 1333.01 172.74C1332.44 173.06 1331.79 173.22 1331.07 173.22C1330.46 173.22 1329.89 173.093 1329.37 172.84C1328.87 172.573 1328.46 172.193 1328.15 171.7C1327.85 171.193 1327.69 170.587 1327.69 169.88ZM1332.35 171.56C1332.63 171.56 1332.95 171.48 1333.31 171.32C1333.67 171.147 1333.99 170.94 1334.25 170.7V167.42C1333.05 167.42 1332.15 167.627 1331.55 168.04C1330.97 168.44 1330.67 168.96 1330.67 169.6C1330.67 170.24 1330.82 170.727 1331.11 171.06C1331.42 171.393 1331.83 171.56 1332.35 171.56ZM1340.4 158.38L1338.92 158.12V157.04L1342.62 156.6H1342.66L1343.2 156.98V171.64L1344.66 171.8V173H1339V171.8L1340.4 171.62V158.38Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368 130H1368.38V129.625H1368V130ZM1368 202V202.375H1368.38V202H1368ZM1296 130V130.375H1368V130V129.625H1296V130ZM1368 130H1367.62V202H1368H1368.38V130H1368ZM1368 202V201.625H1296V202V202.375H1368V202Z",
    fill: "#785E32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 130,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008 202V201.625H1007.62V202H1008ZM1008 274H1007.62V274.375H1008V274ZM1008 202V202.375H1080V202V201.625H1008V202ZM1080 274V273.625H1008V274V274.375H1080V274ZM1008 274H1008.38V202H1008H1007.62V274H1008Z",
    fill: "#785E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1046.36 231.64L1044.76 231.38V230.14H1055.42L1055.68 233.5H1054.28L1053.62 231.52L1049.3 231.34V236.72L1052.08 236.66L1052.4 235.02H1053.68V239.86H1052.4L1052.08 238.14L1049.3 238.08V243.72L1054.14 243.48L1055.3 240.92L1056.8 241.34L1056.28 245H1044.78V243.8L1046.36 243.6V231.64ZM1059.13 235.78L1057.85 235.42V234.04L1061.17 233.62H1061.23L1061.73 234.02V234.8L1061.71 235.28C1062.17 234.84 1062.78 234.46 1063.53 234.14C1064.27 233.82 1065.03 233.66 1065.79 233.66C1066.6 233.66 1067.23 233.813 1067.69 234.12C1068.15 234.413 1068.49 234.88 1068.69 235.52C1068.89 236.16 1068.99 237.027 1068.99 238.12V243.64L1070.21 243.8V245H1065.05V243.8L1066.13 243.64V238.12C1066.13 237.427 1066.08 236.887 1065.99 236.5C1065.89 236.1 1065.72 235.813 1065.47 235.64C1065.23 235.453 1064.88 235.36 1064.43 235.36C1063.67 235.36 1062.85 235.687 1061.99 236.34V243.62L1063.19 243.8V245H1057.97V243.8L1059.13 243.62V235.78ZM1076.66 245.22C1074.9 245.22 1073.59 244.707 1072.72 243.68C1071.87 242.64 1071.44 241.227 1071.44 239.44C1071.44 238.24 1071.66 237.2 1072.1 236.32C1072.55 235.44 1073.19 234.767 1074 234.3C1074.81 233.833 1075.75 233.6 1076.82 233.6C1078.15 233.6 1079.18 233.953 1079.9 234.66C1080.62 235.353 1080.99 236.347 1081.02 237.64C1081.02 238.52 1080.97 239.173 1080.86 239.6H1074.36C1074.41 240.813 1074.7 241.76 1075.22 242.44C1075.74 243.107 1076.48 243.44 1077.44 243.44C1077.96 243.44 1078.49 243.353 1079.04 243.18C1079.6 243.007 1080.04 242.8 1080.36 242.56L1080.86 243.66C1080.5 244.047 1079.91 244.407 1079.1 244.74C1078.3 245.06 1077.49 245.22 1076.66 245.22ZM1078.22 238.4C1078.25 238.027 1078.26 237.74 1078.26 237.54C1078.26 235.767 1077.67 234.88 1076.48 234.88C1075.83 234.88 1075.32 235.14 1074.96 235.66C1074.6 236.18 1074.4 237.093 1074.36 238.4H1078.22ZM1082.61 243.82L1083.93 243.66V235.78L1082.65 235.42V234.04L1085.75 233.62H1085.81L1086.31 234.02V234.46L1086.25 236.08H1086.31C1086.41 235.813 1086.63 235.487 1086.97 235.1C1087.32 234.7 1087.75 234.353 1088.27 234.06C1088.81 233.753 1089.38 233.6 1089.99 233.6C1090.29 233.6 1090.54 233.64 1090.75 233.72V236.72C1090.35 236.44 1089.87 236.3 1089.29 236.3C1088.32 236.3 1087.47 236.56 1086.75 237.08V243.64L1089.07 243.82V245H1082.61V243.82ZM1096.87 250.4C1095.08 250.4 1093.79 250.12 1092.99 249.56C1092.19 249 1091.79 248.24 1091.79 247.28C1091.79 246.733 1091.97 246.213 1092.33 245.72C1092.7 245.24 1093.15 244.88 1093.67 244.64C1093.06 244.28 1092.75 243.707 1092.75 242.92C1092.75 242.467 1092.9 242.04 1093.19 241.64C1093.48 241.227 1093.86 240.907 1094.33 240.68C1093.6 240.4 1093.05 239.973 1092.69 239.4C1092.33 238.827 1092.15 238.147 1092.15 237.36C1092.15 236.6 1092.37 235.94 1092.81 235.38C1093.26 234.807 1093.86 234.367 1094.61 234.06C1095.37 233.753 1096.19 233.6 1097.07 233.6C1098.63 233.6 1099.79 233.9 1100.55 234.5C1100.72 234.273 1101.02 234.06 1101.43 233.86C1101.84 233.66 1102.27 233.56 1102.71 233.56H1103.41V235.74H1101.35C1101.55 236.167 1101.65 236.62 1101.65 237.1C1101.66 238.313 1101.24 239.287 1100.37 240.02C1099.5 240.74 1098.32 241.1 1096.81 241.1C1096.18 241.1 1095.66 241.053 1095.23 240.96C1095.1 241.133 1094.99 241.32 1094.91 241.52C1094.84 241.707 1094.81 241.873 1094.81 242.02C1094.81 242.46 1094.96 242.76 1095.27 242.92C1095.59 243.08 1096.16 243.16 1096.97 243.16H1099.11C1101.83 243.16 1103.19 244.147 1103.19 246.12C1103.19 246.947 1102.9 247.687 1102.31 248.34C1101.72 248.993 1100.94 249.5 1099.97 249.86C1099 250.22 1097.96 250.4 1096.87 250.4ZM1097.01 239.86C1098.25 239.86 1098.87 239.013 1098.87 237.32C1098.87 236.453 1098.71 235.82 1098.39 235.42C1098.08 235.007 1097.61 234.8 1096.97 234.8C1096.34 234.8 1095.86 235.007 1095.51 235.42C1095.18 235.82 1095.01 236.427 1095.01 237.24C1095.01 238.987 1095.68 239.86 1097.01 239.86ZM1097.17 249.02C1098.01 249.02 1098.74 248.813 1099.35 248.4C1099.96 248 1100.27 247.44 1100.27 246.72C1100.27 246.147 1100.12 245.733 1099.81 245.48C1099.52 245.227 1098.98 245.1 1098.21 245.1H1096.03C1095.7 245.1 1095.39 245.08 1095.11 245.04C1094.75 245.52 1094.57 246.093 1094.57 246.76C1094.57 247.493 1094.77 248.053 1095.17 248.44C1095.57 248.827 1096.24 249.02 1097.17 249.02ZM1106.25 249.98C1106.01 249.98 1105.75 249.96 1105.47 249.92C1105.2 249.88 1105.01 249.833 1104.89 249.78V247.64C1104.98 247.693 1105.17 247.747 1105.45 247.8C1105.73 247.853 1105.98 247.88 1106.21 247.88C1106.88 247.88 1107.42 247.66 1107.85 247.22C1108.29 246.78 1108.7 246.04 1109.07 245H1107.99L1104.23 235.3L1103.33 235.04V233.88H1108.83V235.04L1107.37 235.28L1109.15 240.82L1109.87 243.18L1110.49 240.82L1112.13 235.28L1110.87 235.04V233.88H1115.21V235.04L1114.23 235.28C1113.5 237.52 1112.77 239.68 1112.05 241.76C1111.33 243.84 1110.91 245.007 1110.79 245.26C1110.36 246.38 1109.96 247.273 1109.57 247.94C1109.18 248.607 1108.72 249.113 1108.19 249.46C1107.66 249.807 1107.01 249.98 1106.25 249.98Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 202H1152.38V201.625H1152V202ZM1152 274V274.375H1152.38V274H1152ZM1080 202V202.375H1152V202V201.625H1080V202ZM1152 202H1151.62V274H1152H1152.38V202H1152ZM1152 274V273.625H1080V274V274.375H1152V274Z",
    fill: "#785E32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 202,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.818 299.945C910.209 299.945 908.614 300.248 907.115 300.838C904.999 296.421 900.725 294.225 900.53 294.126C900.366 294.043 900.185 294 900.001 294C899.818 294 899.637 294.043 899.473 294.126C899.276 294.221 895.002 296.416 892.887 300.838C891.387 300.248 889.792 299.945 888.182 299.945C887.868 299.945 887.568 300.071 887.346 300.294C887.125 300.517 887 300.819 887 301.135V313.033C887.004 316.18 888.133 319.22 890.18 321.599C892.227 323.977 895.057 325.535 898.15 325.986C898.234 325.997 898.319 325.99 898.4 325.965C898.481 325.94 898.556 325.898 898.619 325.842C898.682 325.785 898.733 325.716 898.767 325.638C898.801 325.56 898.819 325.476 898.818 325.391V317.832C898.814 317.525 898.926 317.228 899.131 317C899.335 316.773 899.618 316.631 899.922 316.605C900.083 316.594 900.245 316.617 900.398 316.672C900.551 316.727 900.69 316.813 900.808 316.924C900.927 317.036 901.021 317.171 901.085 317.32C901.149 317.47 901.182 317.631 901.182 317.795V325.4C901.181 325.485 901.199 325.569 901.233 325.647C901.267 325.725 901.318 325.794 901.381 325.851C901.444 325.907 901.519 325.949 901.6 325.974C901.681 325.999 901.766 326.006 901.85 325.995C904.945 325.543 907.775 323.985 909.823 321.604C911.87 319.224 912.998 316.181 913 313.033V301.135C913 300.819 912.875 300.517 912.654 300.294C912.432 300.071 912.132 299.945 911.818 299.945ZM898.818 313.845C897.734 312.289 896.327 310.99 894.695 310.038C893.062 309.085 891.243 308.502 889.364 308.329V302.39C891.963 302.686 894.363 303.934 896.106 305.897C897.85 307.859 898.815 310.399 898.818 313.033V313.845ZM900 307.583C898.924 305.234 897.186 303.256 895.001 301.895C896.361 299.038 898.901 297.236 900 296.556C901.101 297.237 903.639 299.039 904.999 301.895C902.814 303.256 901.076 305.234 900 307.583ZM910.636 308.327C908.757 308.501 906.938 309.084 905.305 310.036C903.673 310.989 902.266 312.288 901.182 313.843V313.033C901.185 310.399 902.15 307.859 903.894 305.897C905.637 303.934 908.037 302.686 910.636 302.39V308.327Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152 274V273.625H1151.62V274H1152ZM1152 346H1151.62V346.375H1152V346ZM1152 274V274.375H1224V274V273.625H1152V274ZM1224 346V345.625H1152V346V346.375H1224V346ZM1152 346H1152.38V274H1152H1151.62V346H1152Z",
    fill: "#785E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.2 303.64L1191.04 303.38V302.14H1197.28L1199.66 310.74L1200.22 313.08L1200.7 310.74L1203.06 302.14H1209.24V303.38L1207.06 303.64L1208.66 315.58L1210.28 315.8V317H1203.9V315.8L1205.66 315.6L1204.78 306.84L1204.4 303.18L1203.66 306.26L1200.76 316.38H1198.64L1195.68 306.78L1194.66 303.18L1194.36 306.84L1193.6 315.6L1195.62 315.8V317H1190.06V315.8L1191.74 315.6L1193.2 303.64ZM1216.27 317.22C1214.51 317.22 1213.2 316.707 1212.33 315.68C1211.48 314.64 1211.05 313.227 1211.05 311.44C1211.05 310.24 1211.27 309.2 1211.71 308.32C1212.17 307.44 1212.8 306.767 1213.61 306.3C1214.43 305.833 1215.37 305.6 1216.43 305.6C1217.77 305.6 1218.79 305.953 1219.51 306.66C1220.23 307.353 1220.61 308.347 1220.63 309.64C1220.63 310.52 1220.58 311.173 1220.47 311.6H1213.97C1214.03 312.813 1214.31 313.76 1214.83 314.44C1215.35 315.107 1216.09 315.44 1217.05 315.44C1217.57 315.44 1218.11 315.353 1218.65 315.18C1219.21 315.007 1219.65 314.8 1219.97 314.56L1220.47 315.66C1220.11 316.047 1219.53 316.407 1218.71 316.74C1217.91 317.06 1217.1 317.22 1216.27 317.22ZM1217.83 310.4C1217.86 310.027 1217.87 309.74 1217.87 309.54C1217.87 307.767 1217.28 306.88 1216.09 306.88C1215.44 306.88 1214.93 307.14 1214.57 307.66C1214.21 308.18 1214.01 309.093 1213.97 310.4H1217.83ZM1225.59 317.18C1224.75 317.18 1224.13 316.987 1223.73 316.6C1223.33 316.213 1223.13 315.6 1223.13 314.76V307.42H1221.83V306.38C1221.93 306.34 1222.13 306.273 1222.41 306.18C1222.69 306.073 1222.9 305.987 1223.05 305.92C1223.27 305.747 1223.47 305.447 1223.63 305.02C1223.75 304.74 1223.97 304.047 1224.29 302.94H1225.89L1225.97 305.88H1229.03V307.42H1225.99V313.04C1225.99 313.787 1226.01 314.313 1226.05 314.62C1226.09 314.927 1226.17 315.127 1226.31 315.22C1226.44 315.3 1226.67 315.34 1227.01 315.34C1227.34 315.34 1227.69 315.307 1228.05 315.24C1228.41 315.16 1228.71 315.067 1228.95 314.96L1229.33 316.08C1228.95 316.36 1228.41 316.613 1227.69 316.84C1226.97 317.067 1226.27 317.18 1225.59 317.18ZM1230.17 313.88C1230.17 312.667 1230.78 311.753 1231.99 311.14C1233.22 310.527 1234.8 310.213 1236.73 310.2V309.74C1236.73 309.193 1236.67 308.767 1236.55 308.46C1236.45 308.153 1236.24 307.927 1235.93 307.78C1235.64 307.62 1235.21 307.54 1234.63 307.54C1233.98 307.54 1233.39 307.627 1232.87 307.8C1232.35 307.96 1231.81 308.173 1231.25 308.44L1230.63 307.16C1230.83 306.987 1231.17 306.78 1231.63 306.54C1232.11 306.3 1232.68 306.093 1233.33 305.92C1233.99 305.733 1234.66 305.64 1235.35 305.64C1236.38 305.64 1237.18 305.773 1237.75 306.04C1238.34 306.307 1238.76 306.733 1239.01 307.32C1239.27 307.907 1239.39 308.693 1239.39 309.68V315.8H1240.47V316.92C1240.21 316.987 1239.83 317.053 1239.33 317.12C1238.84 317.187 1238.41 317.22 1238.03 317.22C1237.58 317.22 1237.27 317.153 1237.11 317.02C1236.97 316.887 1236.89 316.613 1236.89 316.2V315.66C1236.53 316.06 1236.07 316.42 1235.49 316.74C1234.92 317.06 1234.27 317.22 1233.55 317.22C1232.94 317.22 1232.37 317.093 1231.85 316.84C1231.35 316.573 1230.94 316.193 1230.63 315.7C1230.33 315.193 1230.17 314.587 1230.17 313.88ZM1234.83 315.56C1235.11 315.56 1235.43 315.48 1235.79 315.32C1236.15 315.147 1236.47 314.94 1236.73 314.7V311.42C1235.53 311.42 1234.63 311.627 1234.03 312.04C1233.45 312.44 1233.15 312.96 1233.15 313.6C1233.15 314.24 1233.3 314.727 1233.59 315.06C1233.9 315.393 1234.31 315.56 1234.83 315.56ZM1242.88 302.38L1241.4 302.12V301.04L1245.1 300.6H1245.14L1245.68 300.98V315.64L1247.14 315.8V317H1241.48V315.8L1242.88 315.62V302.38ZM1250.74 315.36C1250.84 315.52 1251.08 315.673 1251.46 315.82C1251.84 315.953 1252.23 316.02 1252.62 316.02C1253.24 316.02 1253.71 315.893 1254.02 315.64C1254.34 315.373 1254.5 315.027 1254.5 314.6C1254.5 314.16 1254.3 313.807 1253.92 313.54C1253.53 313.26 1252.88 312.92 1251.96 312.52L1251.4 312.28C1250.48 311.893 1249.79 311.427 1249.34 310.88C1248.88 310.333 1248.66 309.627 1248.66 308.76C1248.66 308.16 1248.84 307.627 1249.2 307.16C1249.56 306.68 1250.06 306.307 1250.72 306.04C1251.37 305.773 1252.12 305.64 1252.98 305.64C1253.6 305.64 1254.14 305.68 1254.58 305.76C1255.03 305.84 1255.5 305.947 1256 306.08C1256.26 306.173 1256.46 306.227 1256.6 306.24V308.86H1255.02L1254.56 307.34C1254.48 307.207 1254.3 307.087 1254.02 306.98C1253.74 306.873 1253.42 306.82 1253.06 306.82C1252.51 306.82 1252.07 306.94 1251.74 307.18C1251.42 307.407 1251.26 307.727 1251.26 308.14C1251.26 308.513 1251.37 308.827 1251.6 309.08C1251.82 309.32 1252.07 309.507 1252.34 309.64C1252.6 309.773 1253.1 309.993 1253.82 310.3C1254.54 310.607 1255.13 310.9 1255.6 311.18C1256.08 311.46 1256.47 311.827 1256.78 312.28C1257.1 312.72 1257.26 313.26 1257.26 313.9C1257.26 314.887 1256.87 315.687 1256.1 316.3C1255.32 316.913 1254.21 317.22 1252.76 317.22C1252.08 317.22 1251.46 317.16 1250.92 317.04C1250.38 316.92 1249.76 316.76 1249.06 316.56L1248.62 316.42V313.78H1250.28L1250.74 315.36Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296 274H1296.38V273.625H1296V274ZM1296 346V346.375H1296.38V346H1296ZM1224 274V274.375H1296V274V273.625H1224V274ZM1296 274H1295.62V346H1296H1296.38V274H1296ZM1296 346V345.625H1224V346V346.375H1296V346Z",
    fill: "#785E32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 274,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936 346V345.625H935.625V346H936ZM936 418H935.625V418.375H936V418ZM936 346V346.375H1008V346V345.625H936V346ZM1008 418V417.625H936V418V418.375H1008V418ZM936 418H936.375V346H936H935.625V418H936Z",
    fill: "#785E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.46 374.06H955.52L960.14 387.6L961.3 387.8V389H955.4V387.8L956.9 387.6L956.12 385H950.94L950.16 387.62L951.78 387.8V389H946.68L946.66 387.8L947.86 387.6L952.46 374.06ZM953.84 377.44L953.48 375.88L953.1 377.46L951.32 383.6H955.72L953.84 377.44ZM966.783 394.4C964.996 394.4 963.703 394.12 962.903 393.56C962.103 393 961.703 392.24 961.703 391.28C961.703 390.733 961.883 390.213 962.243 389.72C962.616 389.24 963.063 388.88 963.583 388.64C962.97 388.28 962.663 387.707 962.663 386.92C962.663 386.467 962.81 386.04 963.103 385.64C963.396 385.227 963.776 384.907 964.243 384.68C963.51 384.4 962.963 383.973 962.603 383.4C962.243 382.827 962.063 382.147 962.063 381.36C962.063 380.6 962.283 379.94 962.723 379.38C963.176 378.807 963.776 378.367 964.523 378.06C965.283 377.753 966.103 377.6 966.983 377.6C968.543 377.6 969.703 377.9 970.463 378.5C970.636 378.273 970.93 378.06 971.343 377.86C971.756 377.66 972.183 377.56 972.623 377.56H973.323V379.74H971.263C971.463 380.167 971.563 380.62 971.563 381.1C971.576 382.313 971.15 383.287 970.283 384.02C969.416 384.74 968.23 385.1 966.723 385.1C966.096 385.1 965.57 385.053 965.143 384.96C965.01 385.133 964.903 385.32 964.823 385.52C964.756 385.707 964.723 385.873 964.723 386.02C964.723 386.46 964.876 386.76 965.183 386.92C965.503 387.08 966.07 387.16 966.883 387.16H969.023C971.743 387.16 973.103 388.147 973.103 390.12C973.103 390.947 972.81 391.687 972.223 392.34C971.636 392.993 970.856 393.5 969.883 393.86C968.91 394.22 967.876 394.4 966.783 394.4ZM966.923 383.86C968.163 383.86 968.783 383.013 968.783 381.32C968.783 380.453 968.623 379.82 968.303 379.42C967.996 379.007 967.523 378.8 966.883 378.8C966.256 378.8 965.77 379.007 965.423 379.42C965.09 379.82 964.923 380.427 964.923 381.24C964.923 382.987 965.59 383.86 966.923 383.86ZM967.083 393.02C967.923 393.02 968.65 392.813 969.263 392.4C969.876 392 970.183 391.44 970.183 390.72C970.183 390.147 970.03 389.733 969.723 389.48C969.43 389.227 968.896 389.1 968.123 389.1H965.943C965.61 389.1 965.303 389.08 965.023 389.04C964.663 389.52 964.483 390.093 964.483 390.76C964.483 391.493 964.683 392.053 965.083 392.44C965.483 392.827 966.15 393.02 967.083 393.02ZM974.384 387.82L975.704 387.66V379.78L974.424 379.42V378.04L977.524 377.62H977.584L978.084 378.02V378.46L978.024 380.08H978.084C978.178 379.813 978.398 379.487 978.744 379.1C979.091 378.7 979.524 378.353 980.044 378.06C980.578 377.753 981.151 377.6 981.764 377.6C982.058 377.6 982.311 377.64 982.524 377.72V380.72C982.124 380.44 981.638 380.3 981.064 380.3C980.091 380.3 979.244 380.56 978.524 381.08V387.64L980.844 387.82V389H974.384V387.82ZM986.178 376.06C985.698 376.06 985.318 375.92 985.038 375.64C984.758 375.36 984.618 375 984.618 374.56C984.618 374.053 984.778 373.633 985.098 373.3C985.418 372.967 985.845 372.8 986.378 372.8C986.912 372.8 987.318 372.947 987.598 373.24C987.878 373.52 988.018 373.873 988.018 374.3C988.018 374.833 987.858 375.26 987.538 375.58C987.218 375.9 986.772 376.06 986.198 376.06H986.178ZM985.118 379.78L983.698 379.4V378.06L987.358 377.62H987.398L987.958 378.02V387.64L989.298 387.8V389H983.718V387.8L985.118 387.62V379.78ZM990.472 383.5C990.472 382.353 990.699 381.333 991.152 380.44C991.619 379.547 992.279 378.853 993.132 378.36C993.999 377.853 995.005 377.6 996.152 377.6C996.685 377.6 997.145 377.64 997.532 377.72C997.919 377.8 998.352 377.907 998.832 378.04L999.412 378.2L999.292 381.62H997.552L997.052 379.42C996.972 379.073 996.579 378.9 995.872 378.9C995.125 378.9 994.539 379.227 994.112 379.88C993.699 380.533 993.485 381.553 993.472 382.94C993.472 384.407 993.725 385.533 994.232 386.32C994.739 387.093 995.412 387.48 996.252 387.48C997.265 387.48 998.199 387.207 999.052 386.66L999.512 387.7C999.165 388.073 998.632 388.42 997.912 388.74C997.205 389.06 996.439 389.22 995.612 389.22C993.905 389.22 992.619 388.693 991.752 387.64C990.899 386.587 990.472 385.207 990.472 383.5ZM1010.12 389.2C1009.68 389.2 1009.36 389.107 1009.16 388.92C1008.96 388.733 1008.86 388.453 1008.86 388.08V387.54C1008.5 387.98 1008 388.373 1007.34 388.72C1006.69 389.053 1006.04 389.22 1005.38 389.22C1004.1 389.22 1003.19 388.893 1002.64 388.24C1002.1 387.573 1001.82 386.48 1001.82 384.96V379.32L1000.82 379.04V377.9L1004.22 377.64H1004.24L1004.64 377.92V384.96C1004.64 385.933 1004.76 386.613 1005 387C1005.24 387.387 1005.69 387.58 1006.34 387.58C1007.13 387.58 1007.86 387.273 1008.54 386.66V379.32L1007.2 379.02V377.9L1010.82 377.64H1010.86L1011.34 377.92V387.76H1012.46L1012.44 388.9C1012.39 388.913 1012.14 388.967 1011.7 389.06C1011.26 389.153 1010.74 389.2 1010.12 389.2ZM1015.04 374.38L1013.56 374.12V373.04L1017.26 372.6H1017.3L1017.84 372.98V387.64L1019.3 387.8V389H1013.64V387.8L1015.04 387.62V374.38ZM1024.03 389.18C1023.19 389.18 1022.57 388.987 1022.17 388.6C1021.77 388.213 1021.57 387.6 1021.57 386.76V379.42H1020.27V378.38C1020.38 378.34 1020.57 378.273 1020.85 378.18C1021.13 378.073 1021.35 377.987 1021.49 377.92C1021.72 377.747 1021.91 377.447 1022.07 377.02C1022.19 376.74 1022.41 376.047 1022.73 374.94H1024.33L1024.41 377.88H1027.47V379.42H1024.43V385.04C1024.43 385.787 1024.45 386.313 1024.49 386.62C1024.53 386.927 1024.62 387.127 1024.75 387.22C1024.89 387.3 1025.12 387.34 1025.45 387.34C1025.79 387.34 1026.13 387.307 1026.49 387.24C1026.85 387.16 1027.15 387.067 1027.39 386.96L1027.77 388.08C1027.4 388.36 1026.85 388.613 1026.13 388.84C1025.41 389.067 1024.71 389.18 1024.03 389.18ZM1037.86 389.2C1037.42 389.2 1037.1 389.107 1036.9 388.92C1036.7 388.733 1036.6 388.453 1036.6 388.08V387.54C1036.24 387.98 1035.73 388.373 1035.08 388.72C1034.42 389.053 1033.77 389.22 1033.12 389.22C1031.84 389.22 1030.92 388.893 1030.38 388.24C1029.83 387.573 1029.56 386.48 1029.56 384.96V379.32L1028.56 379.04V377.9L1031.96 377.64H1031.98L1032.38 377.92V384.96C1032.38 385.933 1032.5 386.613 1032.74 387C1032.98 387.387 1033.42 387.58 1034.08 387.58C1034.86 387.58 1035.6 387.273 1036.28 386.66V379.32L1034.94 379.02V377.9L1038.56 377.64H1038.6L1039.08 377.92V387.76H1040.2L1040.18 388.9C1040.12 388.913 1039.88 388.967 1039.44 389.06C1039 389.153 1038.47 389.2 1037.86 389.2ZM1041.61 387.82L1042.93 387.66V379.78L1041.65 379.42V378.04L1044.75 377.62H1044.81L1045.31 378.02V378.46L1045.25 380.08H1045.31C1045.4 379.813 1045.62 379.487 1045.97 379.1C1046.32 378.7 1046.75 378.353 1047.27 378.06C1047.8 377.753 1048.38 377.6 1048.99 377.6C1049.28 377.6 1049.54 377.64 1049.75 377.72V380.72C1049.35 380.44 1048.86 380.3 1048.29 380.3C1047.32 380.3 1046.47 380.56 1045.75 381.08V387.64L1048.07 387.82V389H1041.61V387.82ZM1050.81 385.88C1050.81 384.667 1051.41 383.753 1052.62 383.14C1053.85 382.527 1055.43 382.213 1057.37 382.2V381.74C1057.37 381.193 1057.31 380.767 1057.19 380.46C1057.08 380.153 1056.87 379.927 1056.57 379.78C1056.27 379.62 1055.84 379.54 1055.26 379.54C1054.61 379.54 1054.03 379.627 1053.51 379.8C1052.99 379.96 1052.45 380.173 1051.89 380.44L1051.27 379.16C1051.47 378.987 1051.8 378.78 1052.27 378.54C1052.75 378.3 1053.31 378.093 1053.97 377.92C1054.62 377.733 1055.29 377.64 1055.99 377.64C1057.01 377.64 1057.81 377.773 1058.39 378.04C1058.97 378.307 1059.39 378.733 1059.65 379.32C1059.9 379.907 1060.03 380.693 1060.03 381.68V387.8H1061.11V388.92C1060.84 388.987 1060.46 389.053 1059.97 389.12C1059.47 389.187 1059.04 389.22 1058.67 389.22C1058.21 389.22 1057.91 389.153 1057.75 389.02C1057.6 388.887 1057.53 388.613 1057.53 388.2V387.66C1057.17 388.06 1056.7 388.42 1056.13 388.74C1055.55 389.06 1054.91 389.22 1054.19 389.22C1053.57 389.22 1053.01 389.093 1052.49 388.84C1051.98 388.573 1051.57 388.193 1051.27 387.7C1050.96 387.193 1050.81 386.587 1050.81 385.88ZM1055.47 387.56C1055.75 387.56 1056.07 387.48 1056.43 387.32C1056.79 387.147 1057.1 386.94 1057.37 386.7V383.42C1056.17 383.42 1055.27 383.627 1054.67 384.04C1054.08 384.44 1053.79 384.96 1053.79 385.6C1053.79 386.24 1053.93 386.727 1054.23 387.06C1054.53 387.393 1054.95 387.56 1055.47 387.56ZM1063.51 374.38L1062.03 374.12V373.04L1065.73 372.6H1065.77L1066.31 372.98V387.64L1067.77 387.8V389H1062.11V387.8L1063.51 387.62V374.38Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080 346H1080.38V345.625H1080V346ZM1080 418V418.375H1080.38V418H1080ZM1008 346V346.375H1080V346V345.625H1008V346ZM1080 346H1079.62V418H1080H1080.38V346H1080ZM1080 418V417.625H1008V418V418.375H1080V418Z",
    fill: "#785E32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 346,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1406.27 366.274C1406.13 366.152 1405.95 366.068 1405.77 366.027C1405.58 365.987 1405.39 365.991 1405.21 366.041C1405.03 366.09 1404.86 366.183 1404.72 366.312C1404.58 366.44 1404.47 366.601 1404.41 366.779L1401.16 375.729L1397.59 372.261C1397.47 372.144 1397.32 372.054 1397.17 371.997C1397.01 371.94 1396.84 371.917 1396.68 371.929C1396.51 371.942 1396.35 371.99 1396.2 372.069C1396.05 372.149 1395.93 372.259 1395.82 372.392C1392.63 376.597 1391 380.827 1391 384.963C1391 388.421 1392.37 391.737 1394.81 394.182C1397.25 396.626 1400.55 398 1404 398C1407.45 398 1410.75 396.626 1413.19 394.182C1415.63 391.737 1417 388.421 1417 384.963C1417 376.155 1409.5 368.963 1406.27 366.274ZM1412.26 386.347C1411.95 388.063 1411.13 389.644 1409.9 390.877C1408.67 392.11 1407.09 392.936 1405.38 393.243C1405.31 393.254 1405.25 393.26 1405.18 393.259C1404.89 393.259 1404.6 393.147 1404.38 392.946C1404.16 392.745 1404.03 392.468 1404 392.172C1403.98 391.876 1404.07 391.581 1404.25 391.346C1404.43 391.112 1404.69 390.954 1404.99 390.905C1407.43 390.492 1409.51 388.409 1409.93 385.95C1409.98 385.64 1410.15 385.363 1410.41 385.181C1410.66 384.999 1410.98 384.927 1411.29 384.979C1411.6 385.032 1411.88 385.205 1412.06 385.462C1412.24 385.718 1412.31 386.037 1412.26 386.347H1412.26Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.89 463.001C1201.8 463.181 1201.66 463.332 1201.49 463.438C1201.32 463.544 1201.13 463.6 1200.92 463.6H1189.08V468.933C1189.08 469.216 1188.96 469.488 1188.76 469.688C1188.56 469.888 1188.29 470 1188 470C1187.71 470 1187.44 469.888 1187.24 469.688C1187.04 469.488 1186.92 469.216 1186.92 468.933V463.6H1175.08C1174.87 463.6 1174.68 463.544 1174.51 463.438C1174.34 463.332 1174.2 463.181 1174.11 463.002C1174.02 462.822 1173.98 462.622 1174.01 462.424C1174.03 462.225 1174.1 462.036 1174.23 461.879L1180.42 454H1177.23C1177.03 454 1176.83 453.944 1176.66 453.839C1176.49 453.734 1176.35 453.583 1176.26 453.404C1176.17 453.226 1176.14 453.026 1176.16 452.828C1176.18 452.629 1176.25 452.441 1176.38 452.283L1187.15 438.416C1187.25 438.287 1187.38 438.182 1187.52 438.11C1187.67 438.038 1187.83 438 1188 438C1188.16 438 1188.33 438.038 1188.48 438.11C1188.62 438.182 1188.75 438.287 1188.85 438.416L1199.62 452.283C1199.75 452.441 1199.82 452.629 1199.84 452.828C1199.86 453.026 1199.82 453.226 1199.74 453.404C1199.65 453.583 1199.51 453.734 1199.34 453.839C1199.17 453.944 1198.97 454 1198.77 454H1195.59L1201.77 461.879C1201.9 462.036 1201.97 462.225 1201.99 462.423C1202.02 462.622 1201.98 462.822 1201.89 463.001Z",
    fill: "#A38150"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 418,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 864,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 936,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1080,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1152,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1224,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1368,
    y: 490,
    width: 72,
    height: 72,
    stroke: "#785E32",
    strokeWidth: 0.75
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10831_124069",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1440 310) scale(851.5 228.892)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10831_124069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1080,
    fill: "white",
    transform: "translate(0 -230)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComodities);
export default __webpack_public_path__ + "static/media/comodities.be69de0e4dc9a437f57297198e155ae4.svg";
export { ForwardRef as ReactComponent };